module.exports = __webpack_public_path__ + "media/src/img/program_placeholder-e7da04001c2c28016bd284bea64856a3.jpg";